module.exports = __webpack_public_path__ + "static/media/Bolaji-Oginni.3a003158.png";